<mat-card class="bottom-card">
  <div class="card-container">
    <mat-card-header>
      <div matCardAvatar>
        <glxy-avatar
          [width]="AVATAR_WIDTH"
          [icon]="icon"
          shape="square"
          backgroundColor="var(--primary-background-color)"
          textColor="var(--tertiary-text-color)"
        ></glxy-avatar>
      </div>
    </mat-card-header>
    <mat-card-content class="content-container">
      <mat-card appearance="outlined" class="inner-card">
        @if (showTitle) {
          <mat-card-title class="mat-card-title title-with-icon">
            <mat-card-actions>
              <a (click)="toggle()">
                <mat-icon class="expand-icon-card" [class.expanded]="state === 'expanded'"
                  >keyboard_arrow_right</mat-icon
                >
              </a>
            </mat-card-actions>
            <!-- Activity title slot -->
            <ng-content select="[activity-title]"></ng-content>
          </mat-card-title>

          <!-- Activity subtitle slot -->
          <mat-card-subtitle class="activity-subtitle">
            <ng-content select="[activity-subtitle]"></ng-content>
          </mat-card-subtitle>
        }

        <mat-card-content>
          <!-- Always visible content slot -->
          <ng-content select="[activity-preview]"></ng-content>

          <!-- Expandable content -->
          @if (showTitle) {
            <div [@bodyExpansion]="state" class="expandable-content">
              <!-- Association component -->
              @if (activity && showAssociationPopover) {
              <crm-association-popover [activity]="activity" [hideDivider]="true"></crm-association-popover>
            }
            </div>
          }
        </mat-card-content>
      </mat-card>
    </mat-card-content>
  </div>
</mat-card>
